import { type FC, useEffect, useRef } from "react";

/**
 * <MarkupValue/>
 * renders an HTML Element or Text node
 */

export type MarkupValueProps = {
	value: Element | Text;
};

export const MarkupValue: FC<MarkupValueProps> = ({ value }) => {
	const container = useRef<HTMLDivElement | null>(null);

	useEffect(() => {
		const wrapper = container.current;

		if (wrapper) {
			// remove existing children
			wrapper.innerHTML = "";

			// for markdown, if it's multiline, the markdown is wrapped in a div,
			// however, if it's one line, it's not wrapped in a div.
			// for the purpose of css, we need ensure it's always consistently in a div.
			let divWrappedValue = value;
			if (value instanceof Element && value.tagName !== "DIV") {
				const div = document.createElement("div");
				div.appendChild(value);
				divWrappedValue = div;
			}

			// add value to dom
			wrapper.appendChild(divWrappedValue);
		}

		// maybe unnecessary, but remove html again on cleanup
		return () => {
			if (wrapper) {
				wrapper.innerHTML = "";
			}
		};
	}, [value]);

	return <div className="compute-cell-output" ref={container} />;
};
